import { Link } from "react-router-dom";
import type { Ride } from "../types/ride";
import { useUnits } from "../lib/units";
import { formatDate, formatDistance, formatDuration, formatSpeed } from "../lib/units";
import { Badge } from "./Badge";

export function RideCard({ ride }: { ride: Ride }) {
  const { system } = useUnits();
  return (
    <Link
      to={`/rides/${ride.id}`}
      className="flex flex-col gap-2 rounded-xl border border-slate-200 bg-white p-4 transition hover:border-brand-300 hover:shadow-sm dark:border-night-800 dark:bg-night-900 dark:hover:border-brand-700"
    >
      <div className="flex items-start justify-between gap-2">
        <div>
          <div className="font-medium text-slate-900 dark:text-night-50">{ride.title}</div>
          <div className="text-xs text-slate-500 dark:text-night-400">{formatDate(ride.startedAt)}</div>
        </div>
        <div className="flex gap-1">
          {ride.startTimeSource !== "filename" && <Badge tone="warning">approx. time</Badge>}
          {ride.faultCount > 0 && <Badge tone="danger">{ride.faultCount} fault{ride.faultCount === 1 ? "" : "s"}</Badge>}
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2 text-sm">
        <div>
          <div className="text-slate-500 dark:text-night-400">Distance</div>
          <div className="font-medium tabular-nums">{formatDistance(ride.distanceMeters, system)}</div>
        </div>
        <div>
          <div className="text-slate-500 dark:text-night-400">Duration</div>
          <div className="font-medium tabular-nums">{formatDuration(ride.durationSec)}</div>
        </div>
        <div>
          <div className="text-slate-500 dark:text-night-400">Top speed</div>
          <div className="font-medium tabular-nums">{formatSpeed(ride.maxSpeedMs, system)}</div>
        </div>
      </div>
    </Link>
  );
}
